exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".insights-dashboard{display:flex;flex-direction:column;margin:0;height:100%;min-height:0}.insights-dashboard--empty{align-items:center;justify-content:center;padding:2rem;color:#666}.insights-dashboard-iframe{flex:1;width:100%;min-height:0;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ManagerDashboard/InsightsDashboard/InsightsDashboard.scss
// module id = 1744
// module chunks = 0